const AceAccordion = require('./vendor/ace-accordion.js');
const childrenLoaded = require('@alexspirgel/children-loaded');

class Accordion extends HTMLElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		const acfInnerBlocksContainers = this.querySelectorAll('.block-accordion__items > .acf-innerblocks-container');
		for (const acfInnerBlocksContainer of acfInnerBlocksContainers) {
			acfInnerBlocksContainer.replaceWith(...acfInnerBlocksContainer.childNodes);
		}
		this.aceAccordion = new AceAccordion({
			selectors: {
				accordion: '.block-accordion__items',
				item: '.block-accordion__item',
				heading: '.block-accordion__item-heading',
				content: '.block-accordion__item-content',
				content_inner: '.block-accordion__item-content-inner',
			},
		});
	}

}

customElements.define('block-accordion', Accordion, {extends: 'section'});